/**
 * PaymentCancel - Página mostrada cuando se cancela un pago
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeadNoIndex from "../components/Seo/PageHeadNoIndex";
import "./PaymentResult.css";

const PaymentCancel = () => {
	const navigate = useNavigate();

	return (
		<>
			<PageHeadNoIndex
				title="Pago cancelado"
				description="Has cancelado el pago en Viajes Molones. Puedes volver a intentarlo cuando quieras."
			/>
			<div className="payment-result-page">
			<div className="payment-result-card cancel">
				<div className="payment-result-icon">
					<svg
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="12" cy="12" r="10" fill="#F59E0B" />
						<path
							d="M12 8V12M12 16H12.01"
							stroke="white"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>

				<h1>Pago cancelado</h1>

				<p className="payment-result-message">
					Has cancelado el proceso de pago. No se ha realizado ningún cargo.
					Puedes volver a suscribirte o comprar una guía cuando quieras.
				</p>

				<div className="payment-result-actions">
					<button
						className="payment-button primary"
						onClick={() => navigate("/")}
					>
						Ir a las guías
					</button>
				</div>
			</div>
		</div>
		</>
	);
};

export default PaymentCancel;
